export class VendSizeFilter {
    public IncludeInactive?: boolean;
}

export default VendSizeFilter;